import LocalizedStrings from "react-localization";

export const reviewCreativeFiltersStrings = new LocalizedStrings({
  en: {
    status: "Status",
    validated: "Validated",
    rejected: "Rejected",
    productCreated: "Waiting, product created",
    productRequested: "Waiting, product requested",
    creativeId: "Creative ID",
    product: "Product",
    advertiser: "Advertiser",
    paperclipLabel: "Paperclip label",
    adName: "Ad Name",
    adPaid: "Ad Paid",
    startDate: "Start date",
    endDate: "End date",
    keyword: "Keyword",
    search: "Search",
  },
  fr: {
    status: "Statut",
    validated: "Validated",
    rejected: "Rejected",
    productCreated: "Waiting, product created",
    productRequested: "Waiting, product requested",
    creativeId: "Creative ID",
    product: "Produit",
    advertiser: "Annonceur",
    paperclipLabel: "L'étiquette du Trombone",
    adName: "Ad Name",
    adPaid: "Ad Paid",
    startDate: "Date de début",
    endDate: "Date de fin",
    keyword: "Keyword",
    search: "Recherche",
  },
});
